module.exports = __webpack_public_path__ + "img/Le_monde_logo.afcd38ad.svg";